import {
  CALL_OUT_OF_JURISDICTION,
  RTI_DOWNSTREAM_SHARE,
} from '@rsos/constants/collaborator';
import { useCurrentPSAPAccountID } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import {
  getEffectiveCollaborator,
  useGetSelectedCollaborator,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/helpers';
import InfoBanner from './OverviewTab/InfoBanner';

const CollaboratorBanner = () => {
  const rawCollaborator = useGetSelectedCollaborator();
  const currentAccountId = useCurrentPSAPAccountID();
  // Suppresses the primary agency's own copy of an rti_downstream share
  // event -- see getEffectiveCollaborator.
  const collaborator = getEffectiveCollaborator(
    rawCollaborator,
    currentAccountId,
  );

  const callEnded = collaborator?.callEnded || false;

  const getCallStatusText = () => {
    if (callEnded) {
      return 'Call ended.';
    }
    return 'Call in progress.';
  };

  if (!collaborator?.type) {
    return null;
  }

  return (
    <InfoBanner backgroundColor="lightWarning" color="lightWarningText">
      {collaborator.type === CALL_OUT_OF_JURISDICTION ? (
        <>
          Call out of jurisdiction. Caller within{' '}
          <strong>{collaborator.pairedAccountName}</strong> limits.
        </>
      ) : collaborator.type === RTI_DOWNSTREAM_SHARE ? (
        <>
          Call answered by <strong>{collaborator.pairedAccountName}</strong>
          {collaborator.dispatcherPosition && (
            <> — {collaborator.dispatcherPosition}</>
          )}
          . {getCallStatusText()}
        </>
      ) : (
        <>
          Call routed to <strong>{collaborator.pairedAccountName}</strong>
          {collaborator.dispatcherPosition && (
            <>. Answered by position {collaborator.dispatcherPosition}</>
          )}
          . {getCallStatusText()}
        </>
      )}
    </InfoBanner>
  );
};

export default CollaboratorBanner;
